import { useState } from 'react';
import '../../styles/Home.css';
import STEAMnav from '../../nav/STEAM-Nav';

const STEAM2024 = () => {

  return (



    <div className="container">
      <STEAMnav ></STEAMnav>
      <div>
        <h3 className="center-align"><b>STEAM Olympics 2024</b></h3>
      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/FBT.png" alt="" width="70%" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/IWU.png" alt="" width="70%" className="rounded" /></p>
        </div>

      </div>

      <div>
        <h5 className="justify c737373"><a href="/"><b>For A Better Tomorrow (FBT)</b></a> and <a href="https://www.iwu.edu/"><b>Illinois Wesleyan University (IWU)</b></a> recently held the STEAM Olympics for the first time in the McLean County community on April 20th and 21st. The competitive events took place on both days, with an awards ceremony on the 21st starting at 5:00 p.m. The STEAM Olympics aimed to raise funds and advance the missions of FBT and IWU. Half of the proceeds from the event go towards a scholarship for students needing financial assistance, promoting equity and social justice.</h5>
      </div>

      <div>
        <h5 className="justify c737373">"We had 235 registrations and 128 students who participated in the inaugural STEAM Olympics. This is a testament to the need for such an event in our community and the quality of volunteers who brought their enthusiasm to the planning," said Sambisvarao Gurijala, STEAM Olympics Chair.</h5>
      </div>

      <div>
        <h5 className="justify c737373">With over 70 volunteers involved in the event, and support from six sponsors, including iEXCELL (Rahul and Sarika Bafna), Dawn Peters, Drake Zimmerman, Sunil Oberoi, Compeer Financial, and Gen3 Learning (Vanitha GiriPrakash), we were able to raise close to $10,000. This means that in the next few months, barring any additional expenses, IWU will most likely receive a $5,000 scholarship.</h5>
      </div>

      <div>
        <h5 className="justify c737373">Students were able to participate in three different lab tours, graciously offered by IWU faculty and students, including Physics, Chemistry and Biology as well as take part in a 3D printing workshop, offered in collaboration with the nonprofit Makergirl. Various competitive events were held, including a Science Fair, a Science Test, a Math Test developed in collaboration with the Association of Women in Mathematics, a Spelling Bee, a Coding Hackathon, and a Capture the Flag competition. The top three individuals or teams in each category were awarded prizes.</h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Science Fair</b></h4>
          <h5 className="center-align"><i >Judged by Dr. Libby Haywood, Marc Tiritlli, Jonathan Rios and Rokin Prottoy.</i></h5>
        </div>

      </div>

      <p >&nbsp;</p>
      <div className="row">

        <h4 className="center-align">Elementary</h4>
        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SF-E-BV.png" alt="" width="300" height="200" className="rounded" /></p>
          <h6 className="center-align">Best visual: Newton s Law (Rylan Nayak, Mishika Rout, Darshan Ayyanar)</h6>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SF-E-BE.png" alt="" width="300" height="200" className="rounded" /></p>
          <h6 className="center-align">Best execution: Solar Powered Vehicle (Akshay Ayyapusetty, Abhinav Chander, Pradyun Didigam, Saketh Viswanadha)</h6>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SF-E-MC.png" alt="" width="300" height="200" className="rounded" /></p>
          <h6 className="center-align">Most collaborative: Air Adventures (Sivansh Parasa, Kiruthik Guruswami, Achinth Anand)</h6>
        </div>

      </div>

      <p >&nbsp;</p>
      <div className="row">

        <h4 className="center-align">Junior High</h4>
        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SF-JH-BE.png" alt="" width="300" height="200" className="rounded" /></p>
          <h6 className="center-align">Best execution- Gene Therapy Unravelled (Aditi Chander, Sahiti Viswanadha, Harini Hariharan, Shrinath Hariharan)</h6>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SF-JH-BOD.png" alt="" width="300" height="200" className="rounded" /></p>
          <h6 className="center-align">Best original design- Moisture Matters (Lasya Ayapusetty, Charita Bijivemula, Srinidhi Gurijala)</h6>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SF-JH-MC.png" alt="" width="300" height="200" className="rounded" /></p>
          <h6 className="center-align">Most Collaborative- The power of plastic (Vikyath Chatrathi, Jai Mokashi, Anurag Kadiala, Ishan Kulkarni)</h6>
        </div>

      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Science Test</b></h4>
          <h5 className="center-align"><i >Developed, Graded and Reviewed by Mike Jones and Jennifer Smith</i></h5>
        </div>

      </div>

      <p >&nbsp;</p>
      <div className="row">

        <div className="col-sm">

          <h5 className="center-align">Grade 2</h5>
          <h6 className="left-align cGray">Gold: Shree Aytam</h6>
          <h6 className="left-align cGray">Silver: Abhiram Kulkarni</h6>
          <h6 className="left-align cGray">Bronze: Soham Midha, Raelyn Koerner</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 3</h4>
          <h6 className="left-align cGray">Gold: Pahal Sheth</h6>
          <h6 className="left-align cGray">Silver: Hunter Lyons, Rai Manna</h6>
          <h6 className="left-align cGray">Bronze: Kanishkaa Sri Vengala</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 4</h4>
          <h6 className="left-align cGray">Gold: Abhinav Chander</h6>
          <h6 className="left-align cGray">Silver: Akshay Ayyapusetty</h6>
          <h6 className="left-align cGray">Bronze: Ehaan Syed, Rayirth Chandra</h6>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <h5 className="center-align">Grade 5</h5>
          <h6 className="left-align cGray">Gold: Gawyn Edel (overall winner for Elementary)</h6>
          <h6 className="left-align cGray">Silver: Darsh Yadav</h6>
          <h6 className="left-align cGray">Bronze: Neal Sheth</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 6</h4>
          <h6 className="left-align cGray">Gold: Nagapavan Parasa</h6>
          <h6 className="left-align cGray">Silver: Manvi Shukla</h6>
          <h6 className="left-align cGray">Bronze: Sumedha V Yarlagadda</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 7</h4>
          <h6 className="left-align cGray">Gold: Sidak Bindra</h6>
          <h6 className="left-align cGray">Silver: Ayman Mohammed</h6>
          <h6 className="left-align cGray">Bronze: Shloka Chebolu</h6>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

        </div>

        <div className="col-sm">

          <h5 className="center-align">Grade 8</h5>
          <h6 className="left-align cGray">Gold: Ashrith Pulumati (overall winner for Junior High)</h6>
          <h6 className="left-align cGray">Silver: Jeeteshi Giri</h6>
        </div>

        <div className="col-sm">

        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST1.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST2.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST3.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST4.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST5.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST6.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST7.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST8.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST9.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST10.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST11.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST12.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST13.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST14.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST15.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST16.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/ST17.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Math Test</b></h4>
          <h5 className="center-align"><i >Developed, Graded and Reviewed by Dr. Bryanna Petentler and Association of Women in Mathematics, IWU Chapter</i></h5>
        </div>

      </div>

      <p >&nbsp;</p>
      <div className="row">

        <div className="col-sm">

          <h5 className="center-align">Grade 2</h5>
          <h6 className="left-align cGray">Gold: Vedashruti Devari</h6>
          <h6 className="left-align cGray">Silver: Shree Aytam</h6>
          <h6 className="left-align cGray">Bronze: Daksh Sudera</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 3</h4>
          <h6 className="left-align cGray">Gold: Pahal Sheth</h6>
          <h6 className="left-align cGray">Silver: Avyan Manala</h6>
          <h6 className="left-align cGray">Bronze: Sivansh Parasa</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 4</h4>
          <h6 className="left-align cGray">Gold: Elijah Gonzales</h6>
          <h6 className="left-align cGray">Silver: Shiv Midha</h6>
          <h6 className="left-align cGray">Bronze: Abhinav Chander</h6>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <h5 className="center-align">Grade 5</h5>
          <h6 className="left-align cGray">Gold: Neal Sheth (overall winner for Elementary)</h6>
          <h6 className="left-align cGray">Silver: Chandra Padigala</h6>
          <h6 className="left-align cGray">Bronze: Tej Shah</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 6</h4>
          <h6 className="left-align cGray">Gold: Sejal Mheshwari (overall winner for Junior High)</h6>
          <h6 className="left-align cGray">Silver: Nagpavan Parasa</h6>
          <h6 className="left-align cGray">Bronze: Manavi Shukla</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 7</h4>
          <h6 className="left-align cGray">Gold: Rishabh Narendranath (overall winner for Junior High)</h6>
          <h6 className="left-align cGray">Silver: Aditi Chander</h6>
          <h6 className="left-align cGray">Bronze: Shourya Sunchikala, Maheshi Annapragada</h6>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

        </div>

        <div className="col-sm">

          <h5 className="center-align">Grade 8</h5>
          <h6 className="left-align cGray">Gold: Jeeteshi Giri</h6>
        </div>

        <div className="col-sm">

        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT1.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT2.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT3.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT4.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT5.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT6.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT7.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT8.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT9.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT10.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT11.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT12.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT13.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT14.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT15.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT16.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/MT17.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Spelling Bee</b></h4>
        </div>

      </div>

      <p >&nbsp;</p>
      <div className="row">

        <div className="col-sm">

          <h5 className="center-align">Grade 2</h5>
          <h6 className="left-align cGray">Gold: Daksh Sudera</h6>
          <h6 className="left-align cGray">Silver: Emma Goldfarb</h6>
          <h6 className="left-align cGray">Bronze: Aadya Pandranki; Shree Aytam; Soham Midha</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 3</h4>
          <h6 className="left-align cGray">Gold: Emma Hughes</h6>
          <h6 className="left-align cGray">Silver: Kanishka Vengala</h6>
          <h6 className="left-align cGray">Bronze: Aaditha Simon; Rai Manna; Wyatt Barton</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 4</h4>
          <h6 className="left-align cGray">Gold: Abhinav Chander (overall winner for Elementary)</h6>
          <h6 className="left-align cGray">Silver: Kavyamithra Vasantharaman</h6>
          <h6 className="left-align cGray">Bronze: Rayirth Chandra</h6>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <h5 className="center-align">Grade 5</h5>
          <h6 className="left-align cGray">Gold: Gawyn Edel</h6>
          <h6 className="left-align cGray">Silver: Sana Salavath</h6>
          <h6 className="left-align cGray">Bronze: Neal Sheth</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 6</h4>
          <h6 className="left-align cGray">Gold: Nagpavan Parasa (overall winner for Junior High)</h6>
          <h6 className="left-align cGray">Silver: Sejal Maheshwari</h6>
          <h6 className="left-align cGray">Bronze: Sumedha V Yarlagadda</h6>
        </div>

        <div className="col-sm">

          <h4 className="center-align">Grade 7</h4>
          <h6 className="left-align cGray">Gold: Aditi Chander; Ayman Mohammed; Rajas Patil</h6>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB1.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB2.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB3.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB4.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB5.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB6.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB7.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB8.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB9.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB10.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB11.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB12.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB13.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB14.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB15.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB16.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/SB17.png" alt="" width="150" height="150" className="rounded" /></p>
        </div>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Coding Hackathon</b></h4>
        </div>

      </div>

      <p >&nbsp;</p>
      <div className="row">

        <h6 className="center-align cGray">Winning Team (Gold): Ansh Gupta, Krishi Kandury, Aarush Nangunoori</h6>
        <h6 className="center-align cGray">Runner Up Team (Silver): Shriyans Gurijala, Krishna Nair, Dhruv Marlapaty</h6>
      </div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/Hackathon.png" alt="" width="300" height="200" className="rounded" /></p>
        </div>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Capture the Flag</b></h4>
        </div>

      </div>

      <div className="row">

        <h4 className="center-align">Grade 2-5</h4>
        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/CTF25G.png" alt="" width="300" height="200" className="rounded" /></p>
          <h6 className="center-align">Gold: Rylan Nayak, Sivansh Prasa, Thanvika Hariharan, Vedashruti Devari</h6>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/CTF25S.png" alt="" width="300" height="200" className="rounded" /></p>
          <h6 className="center-align">Silver: Aadya Pandranki, Shree Aytam, Mishika Rout, Lakshaya Senthilkumar</h6>
        </div>

      </div>

      <div className="row">

        <h4 className="center-align">Grade 6-8</h4>
        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/CTF68G.png" alt="" width="150" height="150" className="rounded" /></p>
          <h6 className="center-align">Gold: Ryan Nayak</h6>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/CTF68S.png" alt="" width="150" height="150" className="rounded" /></p>
          <h6 className="center-align">Silver: Rayansh Pitti</h6>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/CTF68B.png" alt="" width="150" height="150" className="rounded" /></p>
          <h6 className="center-align">Bronze: Aashrith Pulumati</h6>
        </div>

      </div>

      <div className="row">

        <h4 className="center-align">Grade 9-12</h4>
        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/CTF912G.png" alt="" width="150" height="150" className="rounded" /></p>
          <h6 className="center-align">Gold: Vatsel Sudera</h6>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/CTF912S.png" alt="" width="150" height="150" className="rounded" /></p>
          <h6 className="center-align">Silver: Vishu Devari</h6>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/2024/CTF912B.png" alt="" width="150" height="150" className="rounded" /></p>
          <h6 className="center-align">Bronze: Shriyans Gurijala</h6>
        </div>

      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

    </div>



  );
}
export default STEAM2024;
